import { ReactComponent as Logo } from "assets/images/onstreet-simple.svg";
import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

const SimpleLogo = styled(Logo)`
  margin-bottom: 50px;
  height: 75px;
  min-height: 75px;

  @media (max-width: ${breakpoints.sm}) {
    display: none;
  }
`;

export default SimpleLogo;
